import { styled, useTh } from "leva/plugin";
import { forwardRef } from "react";

const ModalWrapper = styled("div", {
  color: "$highlight3",
  borderRadius: "8px",
  padding: "14px",
  position: "absolute",
  zIndex: 10,
  bottom: "100%",
  marginBottom: "10px",
  display: "grid",
  gap: "16px",
  transform: "translateY(10px)",
  transition: "opacity 100ms, transform 100ms, background-color 100ms",
  opacity: 0,
  pointerEvents: "none",
  backgroundColor: '$modalBackground',
  "&.visible": {
    opacity: 1,
    transform: "translateY(0)",
    pointerEvents: "auto",
  },
  "&.dragging": {
    backgroundColor: '$modalBackgroundDragging',
  },
});


const Triangle = styled("div", {
  position: "absolute",
  bottom: "100%",
  left: "calc(50% - 12px)",
  width: 0,
  height: 0,
  borderTop: "10px solid $modalBackground",
  borderLeft: "12px solid transparent",
  borderRight: "12px solid transparent",
  // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  transform: "translateY(2px)",
  marginBottom: "8px",
  transition: "opacity 100ms, transform 100ms",
  zIndex: 11,
  "&.visible": {
    opacity: 1,
    transform: "translateY(8px)",
  },
  "&.dragging": {
    opacity: .3,
  },
});

interface ModalProps {
  children: React.ReactNode[];
  isVisible: boolean;
  position: { top: number; left: number };
  buttonWidth: number;
  modalAlign?: "left" | "right" | "center" | "center_right" | "center_left";
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  isDragging?: boolean;
}

const Modal = forwardRef<HTMLDivElement, ModalProps>(
  ({ children, isVisible, position, onMouseEnter, onMouseLeave, modalAlign, buttonWidth,isDragging }, ref) => {

  const modalWidth = children.length > 2 ? 284 : 142;
  const gridTemplateColumns = children.length > 2 ? "repeat(2, 1fr)" : "1fr";
  
  let positionStyle = {};
  if (modalAlign === 'left') {
    positionStyle = {left: position.left};
  } else if (modalAlign === 'center') {
    positionStyle = {left: position.left+(buttonWidth/2)-(modalWidth/2)};
  } else if (modalAlign === 'center_left') {
    positionStyle = {left: position.left+(buttonWidth)-(modalWidth/2)};
  } else if (modalAlign === 'center_right') {
    positionStyle = {left: position.left-(modalWidth/2)};
  } else if (modalAlign === 'right') {
    positionStyle = {left: position.left-(modalWidth)+buttonWidth};
  }

  return (
    <>
      {isVisible && <Triangle className={(isVisible ? "visible" : "") + (isDragging ? " dragging" : "")} style={{left: (position.left+buttonWidth/2)-12 }}/>}
      <ModalWrapper
        ref={ref}
        className={(isVisible ? "visible" : "") + (isDragging ? " dragging" : "")}
        style={{gridTemplateColumns, ...positionStyle }}
      >
        {children}
      </ModalWrapper>
    </>
  );
});

export default Modal;